import { render } from "./orgAnalyseDetail.vue?vue&type=template&id=35368ba3&scoped=true"
import script from "./orgAnalyseDetail.vue?vue&type=script&lang=js"
export * from "./orgAnalyseDetail.vue?vue&type=script&lang=js"

import "./orgAnalyseDetail.vue?vue&type=style&index=0&id=35368ba3&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35368ba3"]])

export default __exports__